import { shallowReactive } from 'vue'

import type { CardForm } from '~/scopes/payment/processout'

import type { ProcessOutCardVirtualFieldIds } from '../types/ProcessOutCardFieldIds'
import type {
  ProcessOutVirtualFieldProps,
  ProcessOutVirtualForm,
} from '../types/ProcessOutVirtualForm'

type FormGetter = () => CardForm | null

const requestFocusBuilder =
  (id: ProcessOutCardVirtualFieldIds, getForm: FormGetter) => () => {
    switch (id) {
      case 'cc-number':
        getForm()?.getNumberField().focus()
        break
      case 'cc-cvc':
        getForm()?.getCVCField().focus()
        break
      case 'cc-exp':
        getForm()?.getExpiryField().focus()
        break
      default:
        break
    }
  }

const buildVirtualField = <FieldId extends ProcessOutCardVirtualFieldIds>(
  id: FieldId,
  getForm: FormGetter,
): ProcessOutVirtualFieldProps<FieldId> =>
  shallowReactive({
    id,
    filled: false,
    focused: false,
    invalid: false,
    touched: false,
    error: undefined,
    onRequestFocus: requestFocusBuilder(id, getForm),
  })

export const buildVirtualForm = (
  getForm: FormGetter,
): ProcessOutVirtualForm => {
  return {
    'cc-cvc': buildVirtualField('cc-cvc', getForm),
    'cc-exp': buildVirtualField('cc-exp', getForm),
    'cc-number': buildVirtualField('cc-number', getForm),
    name: shallowReactive({
      id: 'name',
      error: undefined,
    }),
  }
}
